import studentManageJson from "studentManage/studentManageJson"
import systemConfigJson from "systemConfig/systemConfigJson"
const tableKeyName = {
	...studentManageJson,
	...systemConfigJson
}
console.log(tableKeyName)
export default tableKeyName
